module.exports = __webpack_public_path__ + "img/illu_token_w.28af587c.svg";